module.exports = __webpack_public_path__ + "static/media/09.e6de4036.png";